import React, { useState, useEffect, useCallback } from "react";
import type { Editor } from "@tiptap/react";
import styles from "./RichTextEditor.module.css";

type LinkPopoverProps = {
    editor: Editor;
    open: boolean;
    onClose: () => void;
    popoverRef: React.RefObject<HTMLDivElement>;
};

const LinkPopover: React.FC<LinkPopoverProps> = ({ editor, open, onClose, popoverRef }) => {
    const [url, setUrl] = useState("");

    useEffect(() => {
        if (open) {
            const current = editor.getAttributes("link").href;
            setUrl(current || "");
        }
    }, [open, editor]);

    const applyLink = useCallback(() => {
        if (!url) editor.chain().focus().unsetLink().run();
        else editor.chain().focus().setLink({ href: url }).run();
        onClose();
    }, [url, editor, onClose]);

    const handleUrlChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(e.target.value);
    }, []);

    const handleUrlKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
                e.preventDefault();
                applyLink();
            }
        },
        [applyLink]
    );

    if (!open) return null;

    return (
        <div ref={popoverRef} className={styles.popover} data-open={open}>
            <input
                type="url"
                value={url}
                onChange={handleUrlChange}
                placeholder="https://example.com/"
                className={styles.input}
                onKeyDown={handleUrlKeyDown}
                autoFocus
            />
            <div className={styles.popoverActions}>
                <button type="button" onClick={applyLink} className={styles.save} disabled={!url.trim()}>
                    Save
                </button>
            </div>
        </div>
    );
};

export default LinkPopover;
